import { Component, OnInit } from '@angular/core';
import { FacilityDetail, DocumentDetail, ReplacementDraftApplicationModel, ApplicationDetail, PaymentInfoDetail, ReplacementDraftDetail } from '../../models/ApplicationDetail';
import { ApplicationService } from '../../shared/services/application.service';
import { SettingsService } from '../../shared/services/settings.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService } from '../../services/account.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { FacilityService } from '../../shared/services/facility.service';
import { AlertService } from '../../shared/services/alert.service';
import { ReplacementReason, ReplacementApplication, PaymentInfo, ApplicationInfo, FacilityView } from '../../models/ApplicationModel';
import { DocumentRef } from '../../models/DocumentRef';
import { UserDto } from '../../models/User';
import { FileUploader } from 'ng2-file-upload';
import { environment } from '../../../environments/environment';
import * as Constants from '../../models/Constants';
import { FIRItem } from '../../models/CommonModels';
import { ErisLoginService } from '../../services/sso/eris-login.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { withNoScriptValidators } from '../../shared/validators/no-script-input.validator';

const URL =  environment.baseUrl + '/Attachment';

@Component({
  selector: 'app-replace-application',
  templateUrl: './replace-application.component.html',
  styleUrls: ['./replace-application.component.css','../create/create-application.component.css',
  '../application-declaration-letter/application-declaration-letter.component.css']
})
export class ReplaceApplicationComponent implements OnInit {

  
  public facilities: FacilityView[] = [];
  public tabList: Array < string > = ['replacementDetail','fileAttachments'];
  public tab: string;
  public tabIndex: number;
  public buttonName: string;
  public user: UserDto;
  public uploader: FileUploader;
  public selectedFacilityId: number;
  public selectedFacilityCategoryName: string;
  public selectedFacility: FacilityView = null;
  private paymentInfo: PaymentInfo = null;
  public replacementForm: FormGroup;
  public replacementReasons: ReplacementReason[] = [];
  public selectedReason: ReplacementReason;
  public replacementSummary: string;
  public documents: Array<DocumentDetail>;
  public documentRefs: Array<DocumentRef>;
  private allowedFileType = ['pdf'];
  private maxFileSize: number = 6 * 1024 * 1024; // 6 MB
  public draftMode: boolean;
  public replacementDraft: ReplacementDraftApplicationModel;
  public testObject: Object;
  private applicationId: number;
  private editMode = false;
  private applicationDetail: ApplicationDetail;
  public editDocuments: Array < DocumentDetail > ;
  public applicationInfo:ApplicationInfo;
  private draftApplicationId: number;

  constructor(private applicationService: ApplicationService, private settingsService: SettingsService, private fb: FormBuilder,
    private accountService: AccountService, private facilityService: FacilityService, private alertService: AlertService,
    private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService,
    private erisLoginService: ErisLoginService, private errorHandlerService: ErrorHandlerService) {
      this.applicationId = this.route.snapshot.params['id'];
      this.selectedFacilityId = parseInt(this.route.snapshot.queryParams.facilityId);
      const draftMode = this.route.snapshot.params['draft'];
      this.draftMode = (/true/i).test(draftMode);

  }

  ngOnInit() {
  // initial setup
    this.uploader = new FileUploader({
        url: URL,
        allowedFileType: this.allowedFileType,
        maxFileSize: this.maxFileSize,
        headers: [{
          name: 'Authorization',
          value: 'Bearer ' + this.accountService.getTokenData()
        }]
    });

    this.replacementReasons = [new ReplacementReason(1, "Lost"), new ReplacementReason(2, "Damaged")]

    if (this.applicationId) {
      this.editMode = true;
      this.getApplicationForEditing();
    }

    this.facilityService.getFacilitiesForReplacement().subscribe(
      //TODO facilites for replacement
      res => {
        if (res) {
          this.facilities = this.facilities.concat(res);
          if (this.selectedFacilityId) {
            this.selectedFacility = this.facilities.filter(facility => facility.id === this.selectedFacilityId)[0];
            this.selectedFacilityCategoryName = this.selectedFacility.facilityCategoryName;
            this.facilitySelected();
          }
        } else {
          console.log('Error fetching facilities');
        }
      }, err => {
        console.log('Error fetching facilities ' + err);
        this.alertService.error('Error fetching facilities, ' + this.errorHandlerService.handleApiError(err));
      }
    );
    this.buttonName = 'Next';
    this.tabIndex = 0;
    this.tab = this.tabList[this.tabIndex];
    this.user = this.accountService.getUserData();
    this.documentRefs = [];
    this.documents = [];
    this.initializeForm();
  }

  initializeForm() {
    this.replacementForm = this.fb.group({
      paymentInfo: this.fb.group({
        receiptNumber: ['', withNoScriptValidators([Validators.required])]
      })
    });
  }

  getValue(reasonId){
    this.selectedReason = this.replacementReasons.filter((reason) => reason.id == reasonId)[0];
    this.fetchDocumentsForReplacement(this.selectedReason.id);
  }

  fetchDocumentsForReplacement(id){
    this.applicationService.getRequiredDocumentsForReplacement(this.selectedFacility.facilityTypeID,
      this.selectedFacility.productTypeID, 4, null,id).subscribe(
        documents=>{
          this.documentRefs = documents;     
    })
  }

  retrievePaymentDetail(detail) {
    this.paymentInfo = detail;
    console.log('payment detail ', detail);
  }

  facilitySelected() {
    this.documents = [];
    this.selectedFacility = this.facilities.find(fac => fac.id === this.selectedFacilityId);
    if(!this.selectedFacility.productTypeID){
      this.selectedFacility.productTypeID = this.applicationDetail.productTypeID;
    }
  }

  getApplicationForEditing() {
    if(this.draftMode){
       this.draftApplicationId = this.applicationId;
       this.applicationId = null;
         this.applicationService.getDraftApplication(this.draftApplicationId).subscribe(
           res => {
             var draftApplication: ReplacementDraftDetail = new ReplacementDraftDetail(res);
             this.setReplacementApplicationValues(draftApplication,null);
           },
           err => {
             this.alertService.error('Unable to fetch draft application for editing. Please try again later.');
           }
         );
    }
    else{
      this.applicationService.getApplication(this.applicationId).subscribe(
        res => {     
          this.applicationDetail = new ApplicationDetail(res, null);
          this.setReplacementApplicationValues(this.applicationDetail,(<any>res).applicationInfo);
        },
        err => {
          this.alertService.error('Unable to fetch application for editing. Please try again later.');
        }
      );
    }
  }

  setReplacementApplicationValues(application,applicationInfo){
    this.applicationDetail = application;
    this.applicationInfo = applicationInfo;
    this.facilities = this.facilities.concat(application.facility)
    this.editDocuments = application.documents;
    this.selectedFacility = application.facility;
    this.selectedFacilityId = application.facility.id;
    this.facilitySelected();
    if(applicationInfo === null){
      this.replacementSummary = application.summary;
      this.getValue(application.replacementReasonID);
    }
    else{
      this.selectedReason = this.applicationInfo.replacementReason;
      this.replacementSummary = this.applicationInfo.summary;
      this.fetchDocumentsForReplacement(this.selectedReason.id); 
    }    
    this.applicationId = application.id;
    const paymentInfo: PaymentInfoDetail = application.paymentInfos ? (application.paymentInfos.length ? application.paymentInfos[0] : new PaymentInfoDetail({})) : new PaymentInfoDetail({});
    this.replacementForm.get('paymentInfo').get('receiptNumber').setValue(paymentInfo.recieptNumber);
    this.paymentInfo = paymentInfo.recieptNumber || paymentInfo.documentID ? new PaymentInfo(paymentInfo ): null;   
  }
  
  tabClicked(tab) {
    this.tab = tab;
    this.tabIndex = this.tabList.indexOf(tab);
    this.setButtonName();
  }

  activeTab(tab) {
    return this.tab === tab;
  }

  nextClicked() {
    if(this.buttonName === 'Submit'){
      this.submitClicked();
    }
    else{
      this.tabIndex++;
      this.tab = this.tabList[this.tabIndex];
      this.setButtonName();
    }
  }

  buttonsShouldBeDisabled() {
    return !this.selectedFacility || !this.selectedReason;
  }

  nextButtonsShouldBeDisabled() {
    return this.buttonsShouldBeDisabled() || !this.replacementSummary|| !this.selectedReason;
  }

  setButtonName() {
    if (this.tab === 'fileAttachments') {
      this.buttonName = 'Submit';
    } else {
      this.buttonName = 'Next';
    }
  }

  saveReplacement() {
    this.spinner.show();
    const replacementApplicationDraft = new ReplacementApplication(this.selectedFacility,this.documents,this.paymentInfo,this.replacementSummary,this.selectedReason.id);
    replacementApplicationDraft.applicationID = this.applicationDetail ? this.applicationDetail.id : null;
    replacementApplicationDraft.productTypeID = this.applicationDetail ? this.applicationDetail.productTypeID : this.selectedFacility.productTypeID;
    
    this.replacementDraft = new ReplacementDraftApplicationModel(JSON.stringify(replacementApplicationDraft), this.erisLoginService.getUserId());
    
    if(this.editMode){
      this.replacementDraft['id'] = this.applicationDetail['draftID'];
      this.replacementDraft['applicationNumber'] = this.applicationDetail['applicationNumber'];
    }
  
    this.applicationService.saveDraftApplication(this.replacementDraft).subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.alertService.success('Successfully saved replacement application');
        this.router.navigateByUrl('/applications/all');

      } else {
        this.alertService.error('Unable to save draft for application. Please try again later');
      }
    }, error => {
      this.alertService.error(this.errorHandlerService.handleApiError(error));
      this.spinner.hide();
    })
  }

  submitClicked() {
    this.spinner.show();
    if (this.editMode && (!this.draftMode || this.applicationId)) {
      this.paymentInfo.applicationID = this.applicationDetail.id;
      this.paymentInfo.id = this.applicationDetail.paymentInfos[0].id;
      let replacementApplication: ReplacementApplication = new ReplacementApplication(this.selectedFacility,this.documents,this.paymentInfo,this.replacementSummary,this.selectedReason.id);
      replacementApplication.applicationID = this.applicationDetail.id;
      this.applicationService.editReplacementApplication(replacementApplication).subscribe(
        res => {
          this.spinner.hide();
          if (res) {
            this.alertService.success('Successfully submitted application');
            const _this = this;
            if (this.draftMode) {
              /**applicationId is the draft application id in this case */
              this.applicationService.deleteDraftApplication(this.applicationId).subscribe(res=>{
                console.log('Draft version of the application has been removed');
              },err => {
                console.log('Unable to remove the draft version of the application');
                this.alertService.error('Unable to remove the draft version of the application');
              });
            }
            _this.router.navigateByUrl('/applications/list/' + this.applicationDetail.id);
          } else {
            this.alertService.error('Unable to submit application. Please try again later');
          }
        },
        err => {
          this.spinner.hide();
          this.alertService.error('Unable to submit application, ' + this.errorHandlerService.handleApiError(err));
        }
      );

    }else {
    const replacementApplication: ReplacementApplication = new ReplacementApplication(this.selectedFacility,
                                       this.documents,this.paymentInfo,this.replacementSummary,this.selectedReason.id);

    this.applicationService.submitApplicationReplacement(replacementApplication).subscribe(
      res => {
        this.spinner.hide();
        if (res) {
          this.alertService.success('Successfully submitted application');
          const _this = this;
          _this.router.navigateByUrl('/applications/list/' + res.id);

        } else {
          this.alertService.error('Unable to submit application. Please try again later');
        }
      },
      err => {
        this.spinner.hide();
        this.alertService.error('Unable to submit application, ' + this.errorHandlerService.handleApiError(err));
      }
    );
    }
  }

  notFirstTab() {
    return !(this.tabIndex === 0);
  }

  backClicked() {
    this.tab = this.tabList[--this.tabIndex];
    this.setButtonName();
  }

  disableSave(){
    return (!this.selectedFacility || !this.selectedReason || !this.replacementSummary);
  }

  inputDisabled(controlGroup,controlName){
     if (this.applicationDetail && this.applicationDetail.applicationCategory && 
          this.applicationDetail.applicationCategory.name === Constants.APPLICATION_TYPE_NAME_REPLACEMENT &&
            [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode)) {

        let editFields: FIRItem[] = JSON.parse(this.applicationDetail.editedFields)
        let groupIndex = editFields.findIndex(item => item.name === controlGroup);
      if (groupIndex === -1) {
        return true;
      }
      return editFields[groupIndex].subItems.findIndex(item => item.name === controlName) === -1;
    }  
  }


  getFIRDocumentRefs(){

    if(!this.applicationDetail || !([Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode))){
      return undefined;
    }

    let editFields:FIRItem[] = JSON.parse(this.applicationDetail.editedFields);


        let groupIndex = editFields.findIndex(item => item.name === 'Documents');

        if(groupIndex === -1){
          return new FIRItem();
        }
        else{
          return editFields[groupIndex];
        }
  }

  fieldHighlighted(controlGroup,controlName) {
    return { 'input-highlight': this.applicationDetail && [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode)
               && !this.inputDisabled(controlGroup,controlName) };
  }

}
